class QT {
  /**
     * @param { object } options 配置信息
     * @param { string } options.script 加载的qt script文件路径
     * @param { string } options.appKey 加载的qt appkey
     * @param { string } options.logHost 加载的qt日志域名
     * @param { object } options.autotrackConfig qt全局埋点设置
     * @param { boolean } options.autotrackConfig.enable 全局埋点-是否开启
     * @param { object } options.autotrackConfig.collectTags 全局埋点-需要收集的tag元素
     * @param { Array } options.autoExp 自动曝光属性
     * @param { Array } options.autoClk 自动点击属性
     * @param { boolean } options.debug 是否开启debug
     * @param { object } options.globalProperty 全局属性
     */
  constructor(options) {
    this.inited = false; // 是否获取到uId
    this.loaded = false; // script是否加载完成
    this.queue = []; // 队列
    this.logHost = 'quickaplus-he-api-cn-shanghai.aliyuncs.com';
    this.autotrackConfig = {
      enable: true,
    };
    this.autoExp = [
      {
        positionSelector: '.auto-exp-panel',
        cssSelector: '.auto-exp',
        logkey: 'qt_auto_exp',
        props: ['data-auto_exp'],
      },
    ];
    this.autoClk = [
      {
        positionSelector: '.auto-clk-panel',
        cssSelector: '.auto-clk',
        logkey: 'qt_auto_clk',
        props: ['data-auto_clk'],
      },
    ];
    this.debug = false;
    const {
      script, appKey, logHost, autotrackConfig, autoExp, autoClk, debug, globalProperty,
    } = options;
    this.script = script;
    this.appKey = appKey;
    if (logHost) {
      this.logHost = logHost;
    }
    if (autotrackConfig) {
      this.autotrackConfig = { ...this.autotrackConfig, ...autotrackConfig };
    }
    if (autoExp) {
      this.autoExp = autoExp;
    }
    if (autoClk) {
      this.autoClk = autoClk;
    }
    if (debug) {
      this.debug = debug;
    }
    if (globalProperty) {
      this.globalProperty = globalProperty;
    }
  }

  /**
     * 异步加载script文件事件
     */
  load() {
    const script = document.createElement('script');
    script.async = true;
    script.id = 'beacon-aplus';
    script.src = this.script;
    document.head.appendChild(script);
    script.onload = () => {
      this.loaded = true;
      this.refresh();
    };
    script.onerror = () => {
      this.queue = [];
    };
  }

  /**
     * 初始化事件，必须传enable--是否需要uid uid--用户id
     * @param userConfig
     * @returns
     */
  init(userConfig) {
    let _a; let _b; let
      _c;
    if ((userConfig === null || userConfig === void 0 ? void 0 : userConfig.enable) && !userConfig.uid || this.inited) { return; }
    // 设置全局变量aplus_queue
    window.aplus_queue = window.aplus_queue || [];
    this.load();
    // 如果是私有云部署还需要在上面那段JS后面紧接着添加日志域名埋点
    // 通常私有云日志服务端域名类似于：quickaplus-web-api.xxx.com.cn, 具体域名要找交付同学要
    this.action({
      action: 'aplus.setMetaInfo',
      arguments: ['aplus-rhost-v', this.logHost],
    });
    // 设置appKey
    this.action({
      action: 'aplus.setMetaInfo',
      arguments: ['appKey', this.appKey],
    });
    // 是否开启debug
    this.action({
      action: 'aplus.setMetaInfo',
      arguments: ['DEBUG', this.debug],
    });
    // 设置用户id，为了让上报信息带上用户id
    ['_user_id', '_anony_id'].forEach(item => {
      this.action({
        action: 'aplus.setMetaInfo',
        arguments: [item, userConfig === null || userConfig === void 0 ? void 0 : userConfig.uid],
      });
    });
    // 全埋点采集
    // 支持的控件类型
    // 1、默认input，Textarea，button，a四种
    // 2、额外增加通过collect_tags的扩展
    // 3、忽略上报，标签上设置aplus-autotrack-off="true"
    // <tag aplus-autotrack-off="true" ></tag/>
    this.action({
      action: 'aplus.setMetaInfo',
      arguments: [
        'aplus-autotrack-enabled',
        (_b = (_a = this.autotrackConfig) === null || _a === void 0 ? void 0 : _a.enable) !== null && _b !== void 0 ? _b : false,
      ],
    });
    if ((_c = this.autotrackConfig) === null || _c === void 0 ? void 0 : _c.collectTags) {
      this.action({
        action: 'aplus.setMetaInfo',
        arguments: [
          'aplus-autotrack-config',
          {
            collect_tags: this.autotrackConfig.collectTags,
          },
        ],
      });
    }
    // 自动曝光采集
    this.action({
      action: 'aplus.setMetaInfo',
      arguments: ['aplus-auto-exp', this.autoExp],
    });
    // 自动点击采集
    this.action({
      action: 'aplus.setMetaInfo',
      arguments: ['aplus-auto-clk', this.autoClk],
    });
    // 设置全局属性，上报信息带全局属性
    if (this.globalProperty) {
      this.action({
        action: 'aplus.setMetaInfo',
        arguments: ['globalproperty', this.globalProperty],
      });
    }

    this.action({
      action: 'aplus.setMetaInfo',
      arguments: ['aplus-disable-apv', true],
    });

    this.inited = true;
  }

  // 检查是否加载script完成和是否已传uid
  check() {
    return this.inited && this.loaded;
  }

  // 处理队列列表单个push上报
  action(options) {
    this.queue.push(options);
    if (this.check()) {
      aplus_queue.push(this.queue.pop());
    }
  }

  // 把堆积的上报数据清空上报
  refresh() {
    if (this.check()) {
      let len = this.queue.length;
      while (len) {
        aplus_queue.push(this.queue.shift());
        len--;
      }
    }
  }

  /**
     * 埋点方法
     * 详细内容：https://help.aliyun.com/document_detail/428531.html
     * @param { object } options -- 埋点的数据对象
     * @param { string } options.trackerEventCode -- 事件管理的事件编码，按照自己定义的值填入（必须）;
     * @param { string } options.eventType -- 事件类型为字符串枚举类型，可枚举值如下： // 默认其他自定义事件
     *    'EXP': 自定义曝光事件
     *    'CLK': 自定义点击事件
     *    'OTHER': 其他自定义事件
     * @param { JSON } options.eventParams 本次事件中上报的事件参数（属性值）。
     * @param { Function } options.callback -- 执行完埋点push后回调，为了增加记录的准确性，
     * @param { number } options.eventDelay -- 延迟埋点触发，默认0毫秒不延时
     * @param { number } options.cbDelay -- 回调的延时，默认0毫秒不延时
     */
  QTEventTracking(options) {
    try {
      const { trackerEventCode, eventType, eventParams } = options;
      if (!trackerEventCode) {
        console.warn('QT>>>>请填写事件编码');
        return;
      }
      // 推送自定义事件埋点
      this.action({
        action: 'aplus.record',
        arguments: [trackerEventCode, eventType || 'OTHER', eventParams],
      });
      console.log('QT埋点触发,事件编码：', trackerEventCode, '事件描述：', eventParams);
    } catch (e) {
      console.error('QT埋点方法错误', e);
    } finally {
      if (options && options.callback) {
        const { cbDelay } = options;
        const time = Number(cbDelay || 0);
        setTimeout(() => {
          options.callback();
        }, time || 100);
      }
    }
  }

  appendMetaInfo(options) {
    this.action({
      action: 'aplus.appendMetaInfo',
      arguments: ['globalproperty', options],
    });
  }
}

function getQtEnvFn() {
  const type = process.env.ENV_CONFIG;
  const script = 'https://d.alicdn.com/alilog/mlog/aplus/203561150.js';
  let { appKey, debug } = {};
  switch (type) {
  case 'sit':
    appKey = '0nec2b74lfxeloxhbqd3hcun';
    debug = true;
    break;
  case 'prod':
    appKey = 'o1ahcoa956zq7hau4lappo6a';
    debug = false;
    break;
  default:
    appKey = '0nec2b74lfxeloxhbqd3hcun';
    debug = true;
    break;
  }
  return {
    script,
    appKey,
    debug,
  };
}
const getQtEnv = getQtEnvFn();
const QTumeng = new QT({
  script: getQtEnv.script,
  appKey: getQtEnv.appKey,
  debug: getQtEnv.debug,
  globalProperty: {
    source_type: 0,
    page_type: 1,
  },
  autotrackConfig: {
    enable: false,
  },
});

export default QTumeng;



// WEBPACK FOOTER //
// ./src/utils/qt.js